export const sizes = {
  container: {
    desktop: "1048px",
  },
}
